module.exports = __webpack_public_path__ + "i.no1.890cd6d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/i.no1.jpg
// module id = Brnx
// module chunks = 0